<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="100">
          <FormItem label="请求者：">{{dataModel.requester}}</FormItem>
      <FormItem label="日志类型：">{{dataModel.logType}}</FormItem>
      <FormItem label="接口名：">{{dataModel.interfaceLogTitle}}</FormItem>
      <FormItem label="客户端：">{{dataModel.interfaceLogClient}}</FormItem>
      <FormItem label="描述信息：">{{dataModel.interfaceLogDescription}}</FormItem>
      <FormItem label="请求时间：">{{dataModel.logDate}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  created: function () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>